// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "agentsubsystems/v1/agentsubsystems.proto" (package "agentsubsystems.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Agent subsystem configuration RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AgentSubsystemsService } from "./agentsubsystems";
import type { GetSubsystemVersionStatusResponse } from "./agentsubsystems";
import type { GetSubsystemVersionStatusRequest } from "./agentsubsystems";
import type { AdminUndeprecateSubsystemVersionResponse } from "./agentsubsystems";
import type { AdminUndeprecateSubsystemVersionRequest } from "./agentsubsystems";
import type { AdminDeprecateSubsystemVersionResponse } from "./agentsubsystems";
import type { AdminDeprecateSubsystemVersionRequest } from "./agentsubsystems";
import type { AdminListAllSubsystemVersionsResponse } from "./agentsubsystems";
import type { AdminListAllSubsystemVersionsRequest } from "./agentsubsystems";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AgentListSubsystemVersionsResponse } from "./agentsubsystems";
import type { AgentListSubsystemVersionsRequest } from "./agentsubsystems";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service agentsubsystems.v1.AgentSubsystemsService
 */
export interface IAgentSubsystemsServiceClient {
    /**
     * Gets the available versions for the given subsystem and platform
     *
     * @generated from protobuf rpc: AgentListSubsystemVersions(agentsubsystems.v1.AgentListSubsystemVersionsRequest) returns (agentsubsystems.v1.AgentListSubsystemVersionsResponse);
     */
    agentListSubsystemVersions(input: AgentListSubsystemVersionsRequest, options?: RpcOptions): UnaryCall<AgentListSubsystemVersionsRequest, AgentListSubsystemVersionsResponse>;
    /**
     * Viam employees only: lists every version doc for a subsystem across all platforms, including
     * RC, dev, and deprecated versions, plus where each release channel currently points.
     *
     * @generated from protobuf rpc: AdminListAllSubsystemVersions(agentsubsystems.v1.AdminListAllSubsystemVersionsRequest) returns (agentsubsystems.v1.AdminListAllSubsystemVersionsResponse);
     */
    adminListAllSubsystemVersions(input: AdminListAllSubsystemVersionsRequest, options?: RpcOptions): UnaryCall<AdminListAllSubsystemVersionsRequest, AdminListAllSubsystemVersionsResponse>;
    /**
     * Deprecates a released version so it can no longer be served or installed. Marks all platform
     * docs as deprecated tombstones; build artifacts are left in GCS (the tombstones prevent
     * re-discovery). Requires the subsystem_deprecation admin role.
     *
     * @generated from protobuf rpc: AdminDeprecateSubsystemVersion(agentsubsystems.v1.AdminDeprecateSubsystemVersionRequest) returns (agentsubsystems.v1.AdminDeprecateSubsystemVersionResponse);
     */
    adminDeprecateSubsystemVersion(input: AdminDeprecateSubsystemVersionRequest, options?: RpcOptions): UnaryCall<AdminDeprecateSubsystemVersionRequest, AdminDeprecateSubsystemVersionResponse>;
    /**
     * Reverses a deprecation, making the version servable and installable again. Requires the
     * subsystem_deprecation admin role.
     *
     * @generated from protobuf rpc: AdminUndeprecateSubsystemVersion(agentsubsystems.v1.AdminUndeprecateSubsystemVersionRequest) returns (agentsubsystems.v1.AdminUndeprecateSubsystemVersionResponse);
     */
    adminUndeprecateSubsystemVersion(input: AdminUndeprecateSubsystemVersionRequest, options?: RpcOptions): UnaryCall<AdminUndeprecateSubsystemVersionRequest, AdminUndeprecateSubsystemVersionResponse>;
    /**
     * Reports whether a published version has been deprecated.
     *
     * @generated from protobuf rpc: GetSubsystemVersionStatus(agentsubsystems.v1.GetSubsystemVersionStatusRequest) returns (agentsubsystems.v1.GetSubsystemVersionStatusResponse);
     */
    getSubsystemVersionStatus(input: GetSubsystemVersionStatusRequest, options?: RpcOptions): UnaryCall<GetSubsystemVersionStatusRequest, GetSubsystemVersionStatusResponse>;
}
/**
 * @generated from protobuf service agentsubsystems.v1.AgentSubsystemsService
 */
export class AgentSubsystemsServiceClient implements IAgentSubsystemsServiceClient, ServiceInfo {
    typeName = AgentSubsystemsService.typeName;
    methods = AgentSubsystemsService.methods;
    options = AgentSubsystemsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Gets the available versions for the given subsystem and platform
     *
     * @generated from protobuf rpc: AgentListSubsystemVersions(agentsubsystems.v1.AgentListSubsystemVersionsRequest) returns (agentsubsystems.v1.AgentListSubsystemVersionsResponse);
     */
    agentListSubsystemVersions(input: AgentListSubsystemVersionsRequest, options?: RpcOptions): UnaryCall<AgentListSubsystemVersionsRequest, AgentListSubsystemVersionsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AgentListSubsystemVersionsRequest, AgentListSubsystemVersionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Viam employees only: lists every version doc for a subsystem across all platforms, including
     * RC, dev, and deprecated versions, plus where each release channel currently points.
     *
     * @generated from protobuf rpc: AdminListAllSubsystemVersions(agentsubsystems.v1.AdminListAllSubsystemVersionsRequest) returns (agentsubsystems.v1.AdminListAllSubsystemVersionsResponse);
     */
    adminListAllSubsystemVersions(input: AdminListAllSubsystemVersionsRequest, options?: RpcOptions): UnaryCall<AdminListAllSubsystemVersionsRequest, AdminListAllSubsystemVersionsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AdminListAllSubsystemVersionsRequest, AdminListAllSubsystemVersionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Deprecates a released version so it can no longer be served or installed. Marks all platform
     * docs as deprecated tombstones; build artifacts are left in GCS (the tombstones prevent
     * re-discovery). Requires the subsystem_deprecation admin role.
     *
     * @generated from protobuf rpc: AdminDeprecateSubsystemVersion(agentsubsystems.v1.AdminDeprecateSubsystemVersionRequest) returns (agentsubsystems.v1.AdminDeprecateSubsystemVersionResponse);
     */
    adminDeprecateSubsystemVersion(input: AdminDeprecateSubsystemVersionRequest, options?: RpcOptions): UnaryCall<AdminDeprecateSubsystemVersionRequest, AdminDeprecateSubsystemVersionResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AdminDeprecateSubsystemVersionRequest, AdminDeprecateSubsystemVersionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Reverses a deprecation, making the version servable and installable again. Requires the
     * subsystem_deprecation admin role.
     *
     * @generated from protobuf rpc: AdminUndeprecateSubsystemVersion(agentsubsystems.v1.AdminUndeprecateSubsystemVersionRequest) returns (agentsubsystems.v1.AdminUndeprecateSubsystemVersionResponse);
     */
    adminUndeprecateSubsystemVersion(input: AdminUndeprecateSubsystemVersionRequest, options?: RpcOptions): UnaryCall<AdminUndeprecateSubsystemVersionRequest, AdminUndeprecateSubsystemVersionResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AdminUndeprecateSubsystemVersionRequest, AdminUndeprecateSubsystemVersionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Reports whether a published version has been deprecated.
     *
     * @generated from protobuf rpc: GetSubsystemVersionStatus(agentsubsystems.v1.GetSubsystemVersionStatusRequest) returns (agentsubsystems.v1.GetSubsystemVersionStatusResponse);
     */
    getSubsystemVersionStatus(input: GetSubsystemVersionStatusRequest, options?: RpcOptions): UnaryCall<GetSubsystemVersionStatusRequest, GetSubsystemVersionStatusResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSubsystemVersionStatusRequest, GetSubsystemVersionStatusResponse>("unary", this._transport, method, opt, input);
    }
}
